import { TextField, Typography } from "@mui/material";
import { Box } from "@mui/system";
import Stack from "@mui/material/Stack";
type Props = {
  webSiteValues : any;
  handleChange: any;
  formError: any;
}
function SiteWideText({webSiteValues, handleChange, formError} : Props) {

  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
     const {name, value} = e.target;
     handleChange(name,value);
  };
  
  return (
    <>
      <Typography>Site - wide text</Typography>
      <Box mt={1}>
        <TextField
          id="outlined-multiline-flexible"
          name={"site_title"}
          label="Website Name" // Set your label here
          placeholder="What would be the main headline on the site" // Set your placeholder here
          required
          fullWidth
          color="secondary"
          size="small"
          error={formError?.site_title} //-- red border if empty or invalid
          helperText={formError?.site_title ? formError?.site_title : "minimum of 8 characters, only letters, numbers and underscore(_)."}
          onChange={handleInputChange}
          InputLabelProps={{
            shrink: true,
          }}
          value={webSiteValues?.site_title}
          
        />
        <TextField
          fullWidth
          id="outlined-multiline-static"
          name={"advertiser_disclosure"}
          label="Advertiser Disclosure"
          placeholder="Placeholder"
          multiline
          rows={6}
          sx={{ marginTop: "16px" }}
          color="secondary"
          InputLabelProps={{
            shrink: true,
          }}
          value={webSiteValues?.advertiser_disclosure}
          onChange={handleInputChange}
        />
        <TextField
          fullWidth
          id="outlined-multiline-static"
          name={"responsible_gambling"}
          label="Footer Paragraph"
          placeholder="Placeholder"
          multiline
          value={webSiteValues?.responsible_gambling}
          onChange={handleInputChange}
          rows={6}
          sx={{ marginTop: "16px" }}
          color="secondary"
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          fullWidth
          id="outlined-multiline-static"
          name={"copyright"}
          label="Copyright"
          placeholder="Placeholder"
          multiline
          rows={4}
          sx={{ marginTop: "16px" }}
          color="secondary"
          InputLabelProps={{
            shrink: true,
          }}
          value={webSiteValues?.copyright}
          onChange={handleInputChange}
        />
        <Typography
          sx={{ marginTop: "4px", fontSize: "12px", color: "#00000099" }}
        >
          All fields are mandatory.
        </Typography>
        <Typography mt={2}>Secondary Headline</Typography>
        <Stack gap={2} mt={2}>
          <TextField
            size="small"
            fullWidth
            id="outlined-required"
            name={"headline_desktop"}
            label="Desktop"
            color="secondary"
            InputLabelProps={{
              shrink: true,
            }}
            value={webSiteValues?.headline_desktop}
            onChange={handleInputChange}
          />
          <TextField
            size="small"
            fullWidth
            id="outlined-required"
            name={"headline_tablet"}
            label="Tablet"
            color="secondary"
            InputLabelProps={{
              shrink: true,
            }}
            value={webSiteValues?.headline_tablet}
            onChange={handleInputChange}
          />
          <TextField
            size="small"
            fullWidth
            id="outlined-required"
            name={"headline_mobile"}
            label="Mobile"
            color="secondary"
            InputLabelProps={{
              shrink: true,
            }}
            value={webSiteValues?.headline_mobile}
            onChange={handleInputChange}
          />
        </Stack>
      </Box>
    </>
  );
}

export default SiteWideText;
